import React from 'react';
import {useGetMatchingColorsQuery} from '~/api/mms';

export const useColorMatching = ({
  anchorStyle,
  selectedProduct,
  complementStyles,
  isAlternatives,
  colorId,
  quantities
}) => {
  const complementIds = isAlternatives
    ? complementStyles.map(({alternativeId}) => alternativeId)
    : complementStyles.map(({complementId}) => complementId);

  const targetColorId =
    isAlternatives && colorId ? colorId : selectedProduct.colorId;
  const shouldSkip = !anchorStyle || !selectedProduct.colorId;

  const {
    data: colorMatches,
    isLoading,
    isError
  } = useGetMatchingColorsQuery(
    {
      styleId: selectedProduct.styleId,
      colorId: targetColorId,
      complementIds: [anchorStyle?.id, ...complementIds]
    },
    {
      skip: shouldSkip
    }
  );

  const filteredAlternatives = React.useMemo(() => {
    if (
      !isAlternatives ||
      !colorMatches ||
      !quantities ||
      Object.keys(quantities).length === 0
    ) {
      return complementStyles;
    }

    const sizesWithQuantities = Object.keys(quantities[targetColorId]).filter(
      key => quantities[targetColorId][key] > 0
    );

    return complementStyles.filter(complementStyle => {
      const alternativeColor = complementStyle.style.colors.find(
        color => color.id === colorMatches[complementStyle.alternativeId]
      );

      return !sizesWithQuantities.some(size => {
        const sizeStatus = alternativeColor?.sizesWithStatus.find(
          altColor => altColor.name === size
        );
        return sizeStatus?.stock_status === 'out';
      });
    });
  }, [
    isAlternatives,
    colorMatches,
    quantities,
    targetColorId,
    complementStyles
  ]);

  const getColorId = styleId =>
    colorMatches?.[styleId] ? String(colorMatches[styleId]) : undefined;

  return {
    colorMatches,
    isLoading,
    isError,
    filteredAlternatives,
    getColorId,
    shouldSkip
  };
};
